import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProofSection } from './components/ProofSection';
import { OfferSection } from './components/OfferSection';
import { SalesFooter } from './components/SalesFooter';
import { Button } from './components/ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero (approx 800px)
      if (window.scrollY > 800) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen w-full bg-[#FDFBF7] overflow-x-hidden selection:bg-[#7B9E6B]/30" data-id="element-0">
      <main className="flex flex-col items-center w-full" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <ProofSection data-id="element-5" />
        <OfferSection data-id="element-6" />
      </main>
      <SalesFooter data-id="element-7" />

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-8">
        {showStickyCTA && <motion.div initial={{
        y: 100
      }} animate={{
        y: 0
      }} exit={{
        y: 100
      }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-[#2D2A26]/10 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] z-50 md:hidden" data-id="element-9">
            <div className="flex items-center justify-between gap-4 max-w-md mx-auto" data-id="element-10">
              <div className="flex flex-col" data-id="element-11">
                <span className="font-serif font-bold text-[#2D2A26] text-lg" data-id="element-12">
                  No-Fall Plan
                </span>
                <span className="text-sm text-[#7B9E6B] font-medium" data-id="element-13">
                  <span className="line-through text-[#2D2A26]/40 mr-1" data-id="element-14">
                    $19
                  </span>{' '}
                  $6.39 • Instant Access
                </span>
              </div>
              <Button className="py-2 px-6 text-sm shadow-none" onClick={() => document.getElementById('purchase')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} data-id="element-15">
                Get it now
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}